import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Loading, LoadingService } from '@core/service/loading.service';

@Component({
  selector: 'app-loader-inline',
  templateUrl: './loader-inline.component.html',
  styleUrls: ['./loader-inline.component.css']
})
export class LoaderInlineComponent implements OnInit {
  constructor(private loader: LoadingService) {}
  get progressPercentage() {
    return Math.floor(this.progress * 50);
  }

  loaderEstatus: Loading;
  progress = 0;

  @ViewChild('bar') bar: ElementRef;

  ngOnInit(): void {
    setInterval(() => {
      this.progress += 0.001;
      if (this.progress >= 1) {
        this.progress = 0;
      }
    }, 0);

    this.loader.isLoader().subscribe(res => {
      this.loaderEstatus = res;
      // console.log('asdasd', res);
      if (!res.isLoader) {
        this.progress = 0;
      }
    });
  }
}
